import LoginError from './LoginError';
class InvestorHasAlreadyAnActiveSession extends LoginError {
    constructor(options) {
        super('The investor currently has an active session', options);
    }
}
export default InvestorHasAlreadyAnActiveSession;
